//Node Edit Page
import React, { useEffect, useState } from "react";
import { Card, Form } from "react-bootstrap";
import { Button, Col } from "react-bootstrap";
import { notification } from "antd";
import Loader from "../../components/Loader";
import axiosInstance from "../../utils/api";

const NodeEdit = () => {
  const [selected, setSelected] = useState("");
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false)
  const [nodeData, setNodeData] = useState({
    mainNode: [],
  });
  const [values, setvalues] = useState({
    serial: [],
    device: [],
    database_name: [],
    data_table: [],
    mqtt_channel: [],
    project_abb: [],
    telegram_bot: [],
    telegram_channel: [],
    sensor_set: [],
    product_name: [],
    misc: [], //Premise is Misc
    tag_name: [],
    multi_set: [],
    remote: [],
    location_lat: [],
    location_long: [],
    location_name: [],
    location_add: [],
    number_user: [],
  });

  //Get Data from new api
  // Retrieves all the main data from the main node page.
  useEffect(() => {
    setLoading(true)
    axiosInstance.get("https://api.cl-ds.com/kaviNode/")
      .then((fetchdata) => {
        setLoading(false)
        setData(fetchdata.data);
        setNodeData({
          ...nodeData,
          mainNode: fetchdata.data,
        });
        console.log(fetchdata.data);
      }).catch(err=>{
        setLoading(false)
        console.log(err)
      })
    console.log(nodeData.mainNode);
  }, []);

  //finds data, and separates them from the others using serial value.
  const selectedValue = nodeData.mainNode.find(({ serial }) => serial === selected);

  const onCheckhandler = (e) => {
    setvalues({
      ...values,
      [e.target.name]: e.target.checked,
    });
  };

  const openResult = () => {
    console.log(values);
    notification.open({
      message: "Form Data",
      duration: 0,
      description: JSON.stringify(values),
      onClick: () => {
        console.log("Button was clicked");
      },
    });
  };

  function onChangehandler(e) {
    setvalues({
      ...values,
      [e.target.name]: e.target.value,
      serial: document.getElementById("serial")?.value,
      device: document.getElementById("device")?.value,
      database_name: document.getElementById("database")?.value,
      data_table: document.getElementById("datatable")?.value,
      mqtt_channel: document.getElementById("mqtt")?.value,
      telegram_bot: document.getElementById("t_bot")?.value,
      telegram_channel: document.getElementById("t_channel")?.value,
      project_abb: document.getElementById("project")?.value,
      device: document.getElementById("device")?.value,
      sensor_set: document.getElementById("sensor_set")?.value,
      product_name: document.getElementById("product")?.value,
      misc: document.getElementById("premise")?.value,
      tag_name: document.getElementById("tag_name")?.value,
      location_lat: document.getElementById("loc_lat")?.value,
      location_long: document.getElementById("loc_long")?.value,
      location_name: document.getElementById("loc_name")?.value,
      location_add: document.getElementById("loc_add")?.value,
      number_user: document.getElementById("num_user")?.value,
    });
  }

  const afterSubmit = (e) => {
    e.preventDefault();

    console.log(values);
    const reqForPost = {
      method: "POST",
      headers: {
        Authorization: "Token bc78c7bd11ed26f6184ad79f75991c1d18534690",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(values),
    };
    setLoading(true)
    axiosInstance.get("https://api.cl-ds.com/kaviNode/", JSON.stringify(values)).then((response) => {
      setLoading(false)
      if (response.status === 200) {
        console.log(response.json());
      } else console.log(response.json());
    }).catch(err=>{
        setLoading(false)
        console.log(err)
    })
  };

  return (
    <>
    {loading && ( <Loader/> )}
      <span></span>
      <div className="col-lg-8 mx-auto">
        <header>
          <h2 className="text-center"> Dashboard/Node Edit </h2>
        </header>

        <span></span>
        <Card>
          <Card.Header style={{ backgroundColor: "#7952b3", color: "white" }}> Node Edit </Card.Header>

          <Form id="formmain" className="p-2" onSubmit={afterSubmit} onChange={onChangehandler} required>
            <span></span>
            <Form.Row className="d-flex mx-auto">
              <Form.Group className="col-12">
                <Form.Label>Serial</Form.Label>
                <Form.Control as="select" name="serial" id="serial" defaultValue={selectedValue?.serial} onChange={(e) => setSelected(e.target.value)} required>
                  <option value="none" selected disabled hidden>
                    Select an Option
                  </option>
                  {nodeData.mainNode.map(({ serial }) => (
                    <option key={serial} value={serial}>
                      {serial}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Form.Row>

            <Form.Row className="d-flex mx-auto">
              <Form.Group className="col-6">
                <Form.Label>Device</Form.Label>
                <Form.Control
                  type="text"
                  name="device"
                  id="device"
                  placeholder="Device"
                  onChange={(e) => onChangehandler(e)}
                  defaultValue={selectedValue?.device}
                  key={selectedValue?.device}
                  required
                />
                <Form.Control.Feedback type="invalid">Please type a device.</Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="col-6">
                <Form.Label>Tag_name</Form.Label>
                <Form.Control type="text" name="tag_name" id="tag_name" required placeholder="Tag_name" defaultValue={selectedValue?.tag_name} key={selectedValue?.tag_name} />
              </Form.Group>
            </Form.Row>

            <Form.Row className="d-flex mx-auto">
              <Form.Group className="col-12">
                <Form.Label> Database </Form.Label>
                <Form.Control type="text" id="database" placeholder="Database" defaultValue={selectedValue?.database_name} key={selectedValue?.database_name} required></Form.Control>
              </Form.Group>
            </Form.Row>

            <Form.Row className="d-flex mx-auto">
              <Form.Group className="col-12">
                <Form.Label> MQTT </Form.Label>
                <Form.Control type="text" id="mqtt" placeholder="MQTT" defaultValue={selectedValue?.mqtt_channel} key={selectedValue?.mqtt_channel} required></Form.Control>
              </Form.Group>
            </Form.Row>

            <Form.Row className="d-flex mx-auto">
              <Form.Group className="col-5">
                <Form.Label>Project</Form.Label>
                <Form.Control name="project" id="project" placeholder="Project" type="text" defaultValue={selectedValue?.project_abb} key={selectedValue?.project_abb} required></Form.Control>
              </Form.Group>

              <Form.Group className="col-7">
                <Form.Label>Datatable</Form.Label>
                <Form.Control name="datatable" placeholder="Datatable" id="datatable" type="text" required defaultValue={selectedValue?.data_table} key={selectedValue?.data_table}></Form.Control>
              </Form.Group>
            </Form.Row>
            <Form.Row className="d-flex mx-auto">
              <Form.Group className="col-4">
                <Form.Label>T_Bot</Form.Label>
                <Form.Control name="t_bot" id="t_bot" placeholder="T_Bot" type="text" defaultValue={selectedValue?.telegram_bot} key={selectedValue?.telegram_bot}></Form.Control>
              </Form.Group>

              <Form.Group className="col-4">
                <Form.Label>T_Channel</Form.Label>
                <Form.Control
                  name="t_channel"
                  type="text"
                  placeholder="T_Channel"
                  id="t_channel"
                  required
                  defaultValue={selectedValue?.telegram_channel}
                  key={selectedValue?.telegram_channel}
                ></Form.Control>
              </Form.Group>

              <Form.Group className="col-4">
                <Form.Label>Sensor_Set</Form.Label>
                <Form.Control type="number" id="sensor_set" name="Sensor_set" placeholder="sensor_set" required defaultValue={selectedValue?.sensor_set} key={selectedValue?.sensor_set} />
                <Form.Control.Feedback type="invalid">Please type a sensor set.</Form.Control.Feedback>
              </Form.Group>
            </Form.Row>

            <Form.Row className="d-flex mx-auto">
              <Form.Group className="col-6">
                <Form.Label>Location_Lat</Form.Label>
                <Form.Control type="number" name="location_lat" placeholder="Location Latitude" defaultValue={selectedValue?.location_lat} key={selectedValue?.location_lat} required id="loc_lat" />
              </Form.Group>

              <Form.Group className="col-6">
                <Form.Label>Location_Long</Form.Label>
                <Form.Control
                  type="number"
                  name="location_long"
                  placeholder="Location_Longitude"
                  id="loc_long"
                  defaultValue={selectedValue?.location_long}
                  key={selectedValue?.location_long}
                  required
                />
              </Form.Group>
            </Form.Row>

            <Form.Row className="d-flex mx-auto">
              <Form.Group className="col-5">
                <Form.Label>Location_Name</Form.Label>
                <Form.Control type="text" name="location_name" placeholder="Location_Name" id="loc_name" defaultValue={selectedValue?.location_name} key={selectedValue?.location_name} required />
              </Form.Group>

              <Form.Group className="col-7">
                <Form.Label>Location_Add</Form.Label>
                <Form.Control type="text" name="location_add" placeholder="Location_Add" id="loc_add" defaultValue={selectedValue?.location_add} key={selectedValue?.location_add} required />
              </Form.Group>
            </Form.Row>

            <Form.Group as={Col}>
              <Form.Label>Number_User</Form.Label>
              <Form.Control type="number" name="number_user" placeholder="Number_User" defaultValue={selectedValue?.number_user} id="num_user" key={selectedValue?.number_user} required />
            </Form.Group>

            <Form.Group as={Col}>
              <Form.Label>Product</Form.Label>
              <Form.Control type="text" id="product" name="product" placeholder="Product" defaultValue={selectedValue?.product_name} key={selectedValue?.product_name} required />
            </Form.Group>

            <Form.Group as={Col}>
              <Form.Label>Premise</Form.Label>
              <Form.Control type="text" name="premise" id="premise" placeholder="Premise" defaultValue={selectedValue?.misc} key={selectedValue?.misc} required />
            </Form.Group>

            <Form.Row className="d-flex mx-auto">
              <Form.Group className="mb-3 col-2" controlId="formBasicCheckbox">
                <Form.Check type="checkbox" label="Multi_Set" name="multi_set" onChange={onCheckhandler} defaultChecked={selectedValue?.multi_set} key={selectedValue?.multi_set} />
              </Form.Group>

              <Form.Group className="mb-3 col-2" controlId="formBasicCheckbox" as={Col}>
                <Form.Check type="checkbox" label="Remote" name="remote" onChange={onCheckhandler} defaultChecked={selectedValue?.remote} key={selectedValue?.remote} />
              </Form.Group>
            </Form.Row>

            <div className="d-flex justify-content-center mb-5">
              <Button variant="outline-primary" type="submit">
                Submit
              </Button>
            </div>
          </Form>
          <div>
            <Button type="primary" variant="outline-primary" onClick={openResult} className="buttonview ">
              View Data
            </Button>
          </div>
          <br></br>
          <br></br>
        </Card>
      </div>
    </>
  );
};

export default NodeEdit;
